import { useMemo } from 'preact/hooks'

import { checkTargeting } from '@/components/helpers/metaobjects'

/**
 * Takes a criteria object to pass to checkTargeting to validate which
 * variant_text_overrides apply (products, collections, or tags).
 * Returns matches sorted by priority, lowest first.
 */

export function useVariantTextOverrides(criteria) {
  return useMemo(() => {
    const data = GM_STATE?.metaobjects?.variant_text_overrides || []
    return data
      .filter((entry) => checkTargeting(entry, criteria))
      .sort((a, b) => (a.priority ?? 99999) - (b.priority ?? 99999))
  }, [criteria])
}

const equalsIgnoreCase = (a, b) => String(a ?? '').trim().toLowerCase() === String(b ?? '').trim().toLowerCase()

const asNameList = (value) => {
  if (value == null || value === '') return []
  return (Array.isArray(value) ? value : [value]).map((name) => String(name).trim()).filter(Boolean)
}

export function getVariantOptionLabel(overrides, optionValue, optionNames) {
  const values = asNameList(optionValue)
  if (!values.length) return Array.isArray(optionValue) ? '' : optionValue ?? ''

  const names = asNameList(optionNames)
  const match = (overrides || []).find((entry) => {
    if (!values.some((value) => equalsIgnoreCase(entry.option_value, value))) return false
    if (!names.length) return true
    return names.some((name) => equalsIgnoreCase(entry.option_name, name))
  })

  return match?.option_value_override || values[0]
}
